var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("a-alert", {
    attrs: {
      type: "info",
      "show-icon": ""
    }
  }, [_c("template", {
    slot: "message"
  }, [_c("span", [_vm._v("内容将自动调用"), _c("a", {
    attrs: {
      href: "/#/sendtypesetting",
      target: "_blank"
    }
  }, [_vm._v("运输方式设置")]), _vm._v("的数据")])])], 2), _c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("Title", {
    attrs: {
      type: "input"
    },
    model: {
      value: _vm.value.title,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "title", $$v);
      },
      expression: "value.title"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "一级菜单字体色"
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.firstColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "firstColor", $$v);
      },
      expression: "value.firstColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "一级菜单选中颜色"
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.firstCheckColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "firstCheckColor", $$v);
      },
      expression: "value.firstCheckColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "二级菜单字体色"
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.secondColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "secondColor", $$v);
      },
      expression: "value.secondColor"
    }
  })], 1)], 1), _vm.rightCom ? _c("FormEditPage", {
    attrs: {
      show: _vm.show,
      title: "图片设置"
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.show = $event;
      }
    }
  }, [_c("CardItem", {
    attrs: {
      title: "图片",
      layout: "vertical"
    }
  }, [_c("FileUpload", {
    attrs: {
      list: _vm.list
    },
    on: {
      success: function success(val) {
        return _vm.handleImgSuccess(val);
      },
      delete: _vm.handleImg
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };